export default __webpack_public_path__ + "static/media/Avatar-1.b9fb23d2.svg";